<template>
  <v-dialog
    v-model="setDialog"
    :content-class="$vuetify.breakpoint.smAndDown
      ? 'detalhe-compra--mobile' : 'detalhe-compra--desktop'"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    max-width="340"
  >
    <v-card
      class="grey lighten-3"
    >
      <v-app-bar
        v-if="$vuetify.breakpoint.smAndDown"
        max-height="48"
        class="px-0 gradiente-topo"
        dense
        dark
        app
        style="border-radius: 0;"
      >
        <div
          class="d-flex flex-no-wrap align-center"
          style="width: 100%;"
        >
          <v-btn
            icon
            small
            class="ml-0 mr-3 flex-shrink-0"
            data-cy="button_fechar_modal"
            @click="setDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-toolbar-title
            v-if="!loading"
            class="text-truncate body-2 d-block"
            data-cy="titulo_modal"
          >
            {{ data.parent_product_name }}
          </v-toolbar-title>

          <span
            v-if="!loading && data.total_order_bump_items"
            class="ml-4 body-2 flex-shrink-0 flex-grow-1 font-weight-bold"
            data-cy="titulo_order_bump"
          >
            {{ data.total_order_bump_items | getTextItemOrderBump }}
          </span>
        </div>
      </v-app-bar>

      <v-container
        tag="main"
        class="pt-12 pt-md-6"
        style="max-width:1200px"
      >
        <v-btn
          v-if="$vuetify.breakpoint.mdAndUp"
          absolute
          data-cy="button_fechar_modal"
          class="mt-n5 mr-n2"
          icon
          right
          small
          top
          @click="setDialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <ErrorServidor v-if="erro" />


        <div v-else>
          <BannersAds
            v-if="!bannerErro && this.bannersCompras.length > 0"
            :banners="bannersCompras"
            :height-banner="heightBanner()"
            :hide-delimiters="this.bannersCompras.length < 2"
            :seta-banner="false"
            :width-banner="'max-width: 330px'"
            class="mt-6 mb-6"
          />

          <v-divider
            v-if="!bannerErro && this.bannersCompras.length > 0"
            class="mb-6"
          />

          <CardNomeVendedor
            :dados-vendedor="dadosVendedor"
            :loading="loading"
          />

          <CardFotoProduto
            v-if="!produtosCursos.length
              && !produtosApenasDownload.length
              && (!dadosEntrega.address || !dadosEntrega.products.length)"
            :produtos="data.products"
          />

          <v-row>
            <v-col class="py-0 col-12">
              <CardSolicitacaoReembolso
                v-if="data.refund_request_id"
                :dados-da-compra="data"
                @atualizarDados="inicializador"
                @mostrarSnackBar="mostrarSnackBar"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <CardIngressoDigital
                v-if="data.ticket_link"
                :dados-da-compra="data"
              />
            </v-col>
            <v-col class="py-0 col-12">
              <CardEnderecoEntrega
                v-if="produtosEntrega.length"
                :dados-entrega="dadosEntrega"
                :dados-da-compra="data"
                :produtos="produtosEntrega"
                :pagina-vendas="produtoPrincipal.sales_page"
              />
            </v-col>
            <v-col :class="'py-0 col-12 ' + orderDownload">
              <CardProdutoDownload
                v-if="produtosApenasDownload.length"
                :produtos="produtosApenasDownload"
                :possui-card-superior="!!produtosEntrega.length && !orderCurso"
              />
            </v-col>
            <v-col :class="'py-0 col-12 ' + orderCurso">
              <CardAcessarCurso
                v-if="produtosCursos.length"
                :dados-curso="produtosCursos"
                :possui-card-superior="!!produtosEntrega.length && orderCurso"
              />
            </v-col>
          </v-row>

          <v-skeleton-loader
            v-if="loading"
            transition="transition"
            type="article"
            class="mb-5"
            :loading="loading"
          />

          <CardResumoCompra
            :data="data"
            :loading="loading"
          />

          <CardNotaFiscal
            v-if="!loading && notaFiscal.length > 0"
            :notas="data.invoices"
          />

          <CardDadosVendedor
            :dados-do-vendedor="dadosVendedor"
            :notificacao-mensagem="notificacaoMensagem"
            :loading="loading"
          />
          <v-btn
            class="mt-5 mx-auto d-block"
            data-cy="button_nao_encontrei"
            color="primary"
            text
            width="295"
            @click="$router.push(linkAindaPrecisoAjuda);"
          >
            Ainda preciso de ajuda
          </v-btn>
        </div>
      </v-container>
    </v-card>
    <SnackBar
      :mensage="snackBar.message"
      :snackbar="snackBar.show"
      :button="true"
      :color="snackBar.color"
      :timeout="snackBar.timeout"
      @changeSnackBar="snackbar => snackBar.show = snackbar .visible"
    />
  </v-dialog>
</template>

<script>
import ApiCompras from '@/api/compras';
import ApiBanners from '@/api/banners';
import { mapState, mapActions, mapGetters } from 'vuex';

import ErrorServidor from '@/components/ErrorServidor.vue';
import CardEnderecoEntrega from '@/components/Compras/CardEnderecoEntrega.vue';
import CardNomeVendedor from '@/components/Compras/CardNomeVendedor.vue';
import CardResumoCompra from '@/components/Compras/CardResumoCompra.vue';
import CardDadosVendedor from '@/components/Compras/CardDadosVendedor.vue';
import CardAcessarCurso from '@/components/Compras/CardAcessarCurso.vue';
import CardProdutoDownload from '@/components/Compras/CardProdutoDownload.vue';
import CardSolicitacaoReembolso from '@/components/Compras/CardSolicitacaoReembolso.vue';
import CardFotoProduto from '@/components/Compras/CardFotoProduto.vue';
import CardNotaFiscal from '@/components/Compras/CardNotaFiscal.vue';
import CardIngressoDigital from '@/components/Compras/CardIngressoDigital.vue';
import SnackBar from '@/components/SnackBar.vue';
import BannersAds from '@/components/BannersAds.vue';

function getDefaultData() {
  return {
    data: {},
    loading: true,
    erro: false,
    dadosVendedor: {},
    dadosEntrega: {},
    produtosEntrega: [],
    produtosCursos: [],
    produtosApenasDownload: [],
    orderDownload: '',
    orderCurso: '',
    snackBar: {
      message: '',
      show: false,
      color: 'success',
      timeout: 9000,
    },
    bannersCompras: [],
    bannerErro: false,
  };
}

export default {
  name: 'ModalFullScreen',

  components: {
    ErrorServidor,
    CardEnderecoEntrega,
    CardNomeVendedor,
    CardResumoCompra,
    CardDadosVendedor,
    CardAcessarCurso,
    CardProdutoDownload,
    CardSolicitacaoReembolso,
    CardFotoProduto,
    CardNotaFiscal,
    CardIngressoDigital,
    SnackBar,
    BannersAds,
  },

  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    compraId: {
      type: Number,
      required: true,
    },
    notificacaoMensagem: {
      type: Boolean,
      required: true,
    },
  },

  data: getDefaultData,

  computed: {
    linkAindaPrecisoAjuda() {
      if (this.$vuetify.breakpoint.smAndDown) return '/nao-encontrei-o-que-preciso';
      return '/nao-encontrei-o-que-preciso/modal';
    },
    ...mapState(['reloadPage', 'assinaturaCancelada']),
    ...mapState('banners', ['bannerAds']),
    ...mapGetters('banners', ['getBannerAds']),

    notaFiscal() {
      if (this.data.invoices) return this.data.invoices;

      return [];
    },

    setDialog: {
      get() {
        return this.dialog;
      },
      set(v) {
        this.$emit('changeDialog', { visible: v, ...this });
      },
    },

    produtoPrincipal() {
      return this.data.products.find(produto => produto.is_parent);
    },
  },

  mounted() {
    if (this.reloadPage) {
      this.setReloadPage(false);
      this.$router.go();
    } else {
      this.inicializador();
    }
    this.verificaStore();
  },

  methods: {
    ...mapActions(['setReloadPage', 'setAssinaturaCancelada', 'gravarDadosCompra', 'setDadosTransacao']),
    ...mapActions('banners', ['setBannerAds']),

    inicializador(snackBar = null) {
      Object.assign(this.$data, getDefaultData());
      this.getApi(this.compraId);
      this.loading = true;

      if (snackBar) {
        this.mostrarSnackBar(snackBar);
      }
    },

    async getApi(id) {
      this.erro = false;

      await ApiCompras.orderDetails(id)
        .then((response) => {
          this.data = response.data;
          this.fragmentarResposta(this.data);
          this.gravarDadosCompra(this.data);
          this.setDadosTransacao(this.data);
        })
        .catch(() => {
          this.erro = true;
          this.setDadosTransacao({});
        })
        .finally(() => {
          this.loading = false;
          if (this.data.is_membership && this.assinaturaCancelada !== '') {
            this.verificarAssinaturaCancelada();
          }
        });
    },

    async getBannersAds() {
      await ApiBanners.bannersList('detalhes-compra')
        .then((response) => {
          this.gravarStore(response.data);
        })
        .catch(() => {
          this.bannerErro = true;
        });
    },

    gravarStore(data) {
      this.bannersCompras = data;
      const dados = this.bannerAds || {};
      const banner = { detalhesCompra: this.bannersCompras };

      Object.assign(dados, banner);
      this.setBannerAds(dados);
    },

    verificaStore() {
      if (this.getBannerAds('detalhesCompra')) {
        this.bannersCompras = this.getBannerAds('detalhesCompra');
      } else {
        this.getBannersAds();
      }
    },

    heightBanner() {
      if (this.$vuetify.breakpoint.width < 354) {
        return `height: ${((this.$vuetify.breakpoint.width - 10) * 200 / 354)}px`;
      }
      if (this.$vuetify.breakpoint.mdAndUp) {
        return 'height: 179px';
      }
      return 'height: 200px';
    },

    fragmentarResposta(respostaAPI) {
      this.dadosVendedor = respostaAPI.seller;
      this.dadosEntrega = respostaAPI.shipping_address;
      respostaAPI.products.forEach((product) => {
        if (this.dadosEntrega.products && this.dadosEntrega.products.includes(product.id)) {
          this.produtosEntrega.push(product);
        } else {
          if (product.course_link) {
            this.produtosCursos.push(product);
            this.orderCurso = product.is_parent ? 'order-first' : this.orderCurso;
          }
          if (product.downloads.length) {
            this.produtosApenasDownload.push(product);
            this.orderDownload = product.is_parent && !product.course_link ? 'order-first' : this.orderDownload;
          }
        }
      }, this);
    },

    mostrarSnackBar(snackBar) {
      Object.assign(this.snackBar, snackBar);
      this.snackBar.show = true;
    },

    verificarAssinaturaCancelada() {
      const status = this.assinaturaCancelada;
      const snackBar = {
        message: 'Assinatura cancelada com sucesso.',
        timeout: 5000,
      };

      if (status === true) {
        this.mostrarSnackBar(snackBar);
      } else if (status === false) {
        snackBar.message = 'Tente novamente mais tarde.';
        snackBar.color = 'error';
        this.mostrarSnackBar(snackBar);
      }

      this.setAssinaturaCancelada('');
    },
  },
};
</script>

<style scope lang="scss">
html.overflow-y-hidden {
  overflow-y: hidden !important;
}

.detalhe-compra {
  &--desktop {
    border-bottom: 12px solid #EEE;
    border-radius: 1px !important;
    border-top: 12px solid #EEE;
    height: 100vh !important;
    margin: 0 0 0 auto !important;
    max-height: 100% !important;

    .v-sheet {
      border-radius: 1px !important;
      min-height: 100%;
    }
  }
}
</style>
